const cartData = [
	{
		image: 'assets/images/products/img-8.png',
		name: 'Sweatshirt for Men (Pink)',
		color: 'Pink',
		size: 'M',
		price: '119.99',
		quantity: 2,
		total: '239.98',
		id: '1',
	},
	{
		image: 'assets/images/products/img-7.png',
		name: 'Noise NoiseFit Endure Smart Watch',
		color: 'Black',
		size: '32.5mm',
		price: '94.99',
		quantity: 1,
		total: '94.99',
		id: '2',
	},
	{
		image: 'assets/images/products/img-3.png',
		name: '350 ml Glass Grocery Container',
		color: 'White',
		size: '350 ml',
		price: '24.99',
		quantity: 1,
		total: '24.99',
		id: '3',
	},
];

export { cartData };
